/**
 * @generated SignedSource<<5e0317d5723032198a2ef80a2507f090>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type uxSimplificationFeature_useSyncUXSimplificationWithRelay$data = {
  readonly viewer: {
    readonly uxSimplificationEnabled: boolean;
  };
  readonly " $fragmentType": "uxSimplificationFeature_useSyncUXSimplificationWithRelay";
};
export type uxSimplificationFeature_useSyncUXSimplificationWithRelay$key = {
  readonly " $data"?: uxSimplificationFeature_useSyncUXSimplificationWithRelay$data;
  readonly " $fragmentSpreads": FragmentRefs<"uxSimplificationFeature_useSyncUXSimplificationWithRelay">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "uxSimplificationFeature_useSyncUXSimplificationWithRelay",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uxSimplificationEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "9a055d36fabe2e98164da2e09457c724";

export default node;
